export class WebUser {
  user_Id = '';
  firstname = '';
  lastname = '';

  email = '';
  confirmEmail = '';

  password = '';
  confirmPassword = '';

  last_Login_Date = '';
  user_Type_Id = 0;
  user_Type_Name = '';
  company_Id = 0;
  company_Name = '';
  is_Locked_Out = false;

  is_edit = false;
}
